(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class BaseHeader extends HTMLElement {
    constructor() {
      super();
      this.mobileDrawerBtn = this.querySelector('[mobile-drawer-btn]');
      this.mobileDrawerContent = this.querySelector('[mobile-drawer-content]');
      this.section = this.closest('.shopify-section');
      this.initMobileDrawer();
      if (Shopify.designMode) {
        document.body.classList.remove('overflow-hidden');
      }
      if (Shopify.designMode && this.section) {
        this.searchDrawer = document.querySelector('search-drawer-wrapper');
        this.cartDrawer = document.querySelector('cart-drawer');

        this.section.addEventListener('shopify:section:load', () => {
          document.body.classList.remove('overflow-hidden');
          this.searchDrawer?.connectedCallback?.();
          this.cartDrawer?.connectedCallback?.();
        });
      }
      theme?.onMobileSizeChange?.((isMobile) => {
        if (!isMobile && this.mobileDrawerContent?.classList.contains('drawer-open')) {
          this.closeMobileDrawer();
        }
      });
    }

    initMobileDrawer() {
      if (!this.mobileDrawerBtn || !this.mobileDrawerContent) return;
      this.mobileDrawerBtn.addEventListener('click', () => this.openMobileDrawer()); 
      this.mobileDrawerBtn.addEventListener('keydown', (event) =>{
        if (event.key === "Enter") {
          this.openMobileDrawer();
        }
      });

      const closeBtn = this.mobileDrawerContent.querySelector('[drawer-close-btn]');
      const backdrop_close_Btn = this.mobileDrawerContent.querySelector('[drawer-close]');
      if (closeBtn) closeBtn.addEventListener('click', () => this.closeMobileDrawer());
      if (backdrop_close_Btn) backdrop_close_Btn.addEventListener('click', () => this.closeMobileDrawer());

      this.mobileDrawerContent.addEventListener('click', (e) => {
        const backBtn = e.target.closest('[data-back-to-menu]');
        if (backBtn) {
          e.preventDefault();
          backBtn.closest('[data-menu-item]')?.classList.remove('active');
          return;
        }

        if (e.target.tagName === 'A' || e.target.closest('a')) return;

        const menuItem = e.target.closest('[data-menu-item]');
        if (menuItem?.querySelector('.mobile-menu-submenu')) { 
          e.preventDefault();
          menuItem.parentElement.querySelectorAll('[data-menu-item]').forEach((sib) => { 
            if (sib !== menuItem) sib.classList.remove('active');
          }); 
          menuItem.classList.add('active');
        }
      });

      this.mobileDrawerContent.addEventListener('keydown', (event) =>{
          if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      this.closeMobileDrawer();
      this.mobileDrawerBtn.focus();
      return;
    }
       if (event.key === "Enter") {
         const backBtn = event.target.closest('[data-back-to-menu]');
        if (backBtn) {
          event.preventDefault();
          backBtn.closest('[data-menu-item]')?.classList.remove('active');
          setTimeout(() => {
          const isHorizontalCard = backBtn.classList.contains('horizontal-product-card-back');
          const activeWrapper = this.mobileDrawerContent.querySelector('.mobile-menu-item.active');

          const focusTarget = isHorizontalCard && activeWrapper ? activeWrapper : this.mobileDrawerContent;
          trapFocus(focusTarget);  
          }, 500);
          return;
        }

        if (event.target.tagName === 'A' || event.target.closest('a')) return;

        const menuItem = event.target.closest('[data-menu-item]');
        if (menuItem?.querySelector('.mobile-menu-submenu')) { 
          event.preventDefault();
          menuItem.parentElement.querySelectorAll('[data-menu-item]').forEach((sib) => { 
            if (sib !== menuItem) sib.classList.remove('active');
          }); 
          menuItem.classList.add('active');
            setTimeout(() => {
             trapFocus(menuItem);
            }, 500);
        }
       }
      });
    }

    openMobileDrawer() {
      this.mobileDrawerContent.classList.add('drawer-open');
      this.mobileDrawerContent.setAttribute('drawer-open', '');
      document.body.classList.add('overflow-hidden');
      setTimeout(() => {
        trapFocus(this.mobileDrawerContent,this.mobileDrawerContent.querySelector('[drawer-close-btn]'));
      }, 500);
    }

    closeMobileDrawer() {
      this.mobileDrawerContent.classList.remove('drawer-open');
      this.mobileDrawerContent.removeAttribute('drawer-open');
      document.body.classList.remove('overflow-hidden');
      this.querySelectorAll('[data-menu-item].active').forEach((menu) => menu.classList.remove('active'));
    }
  }
  class StickyHeader extends BaseHeader {
    constructor() {
      super();

      this.section = this.closest('.shopify-section');
      this.header = document.querySelector('.section-header');
      this.predictiveSearch = this.querySelector('predictive-search');
      this.headerType = this.getAttribute('data-sticky-type') || '';
      this.headerIsAlwaysSticky = ['always', 'on-scroll-up'].includes(this.headerType);
      this.headerAlways = this.headerType === 'always';
      this.headerBounds = {};
      this.headerHeight = 0;
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.isScrolling = null;
      this.marginHeight;
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };
    }

    connectedCallback() {
      if (this.headerType != 'none') {
        this.setHeaderHeight();
        this.observeMediaQuery();
        this.setupScrollEvents();
        this.createObserver();
      }
    }

    disconnectedCallback() {
      this.cleanupScrollEvents();
    }

    /** ─── Scroll & Sticky Header ───────────────────── */
    observeMediaQuery() {
      const mediaQuery = window.matchMedia('(max-width: 990px)');
      mediaQuery.addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setupScrollEvents() {
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      if (this.headerIsAlwaysSticky) this.header?.classList.add('header-sticky');
    }

    cleanupScrollEvents() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    setHeaderHeight() {
      const headerWrapper = this.closest('.header-main-wrapper');
      if (!headerWrapper) return;

      this.headerHeight = headerWrapper.getBoundingClientRect().height;
      document.body.style.setProperty('--headerHeight', `${this.headerHeight}px`);
      document.body.style.setProperty('--headerDynamicHeight', `${this.headerHeight}px`);
    }

    createObserver() {
      if (!this.header) return;
      const observer = new IntersectionObserver(([entry]) => {
        this.headerBounds = entry.intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    updateDynamicHeight() {
      const headerEl = this.header?.querySelector('header');
      if (!headerEl) return;
      const height = headerEl.getBoundingClientRect().height;
      document.body.style.setProperty('--headerDynamicHeight', `${height}px`);
    }
    onScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      if (this.predictiveSearch?.isOpen) return;
      if (!this.headerIsAlwaysSticky) return;

      const isScrollingDown = scrollTop > this.currentScrollTop;
      const pastHeader = scrollTop > this.headerBounds.bottom;
      const pastThreshold = scrollTop > 50;
      const isMobile = window.innerWidth <= 768;
      const hideThreshold = isMobile ? 300 : 600;
      if (this.headerType === 'on-scroll-up' || this.headerType === 'always') {
        if (pastThreshold && isScrollingDown && pastHeader) {
          if (scrollTop > 50) {
            this.updateDynamicHeight();
            this.header.classList.add('scrolled-header');
            this.toggleSpacing(false);
          }
          if (scrollTop > hideThreshold) {
            if (!this.preventHide) this.hide();
          }
        } else if (!isScrollingDown && pastHeader) {
          this.updateDynamicHeight();
          this.header.classList.add('scrolled-header');
          this.preventReveal ? this.deferHide() : this.reveal();
          this.toggleSpacing(false);
        } else if (scrollTop <= this.headerBounds.top) {
          this.reset(); 
        }
      }

      this.currentScrollTop = scrollTop;
    }

    toggleSpacing(add = true) {
      const isTransparent = this.header?.querySelector('header').classList.contains('header-transparent');
      if (isTransparent){
          this.header?.querySelector('header').classList.toggle('section-spacing', add); 
          if (!this.marginHeight) {
        this.marginHeight = getComputedStyle(document.body).getPropertyValue('--headerMargin').trim();
      }
      if (this.marginHeight && add == false) {
        document.body.style.setProperty('--headerMargin', `0px`);
      }
      }else{
        const wrapper = this.header?.querySelector('[header-main-wrapper]');
        if (!wrapper) return;
        wrapper.classList.toggle('section-spacing', add);
      }
    }

    deferHide() {
      clearTimeout(this.isScrolling);
      this.isScrolling = setTimeout(() => (this.preventReveal = false), 66);
      this.hide();
    }

    /** ─── Header State Methods ─────────────────────── */
    hide() {
      if (this.headerAlways) return;
      document.body.style.setProperty('--headerDynamicHeight', `0px`);
      document.body.classList.add('header-pinned');
      this.header.classList.add('header-hidden', 'header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerAlways) return;
      // document.body.style.setProperty('--headerDynamicHeight', `${this.headerHeight}px`);
      document.body.classList.remove('header-pinned');
      this.header.classList.remove('header-hidden');
      this.header.classList.add('header-sticky', 'animate');
    }

    reset() {
      this.header.classList.remove('scrolled-header');
      document.body.style.setProperty('--headerDynamicHeight', `${this.headerHeight}px`);
      if (this.marginHeight) {
        document.body.style.setProperty('--headerMargin', this.marginHeight);
      }
      this.toggleSpacing(true);
      if (!this.headerAlways) document.body.classList.remove('header-pinned');
    }

    /** ─── Helpers ─────────────────────────────────── */
    closeMenuDisclosure() {
      this.disclosures ??= this.header?.querySelectorAll('header-menu');
      this.disclosures?.forEach((d) => d.close?.());
    }

    closeSearchModal() {
      this.searchModal ??= this.header?.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }
  customElements.define('sticky-header', StickyHeader, { extends: 'header' });

  class BasicHeader extends BaseHeader {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }
    connectedCallback() {
      this.setHeaderHeight();
    }
    setHeaderHeight() {
      const headerWrapper = this.closest('.header-main-wrapper');
      if (!headerWrapper) return;
      this.headerHeight = headerWrapper.getBoundingClientRect().height;
      document.body.style.setProperty('--headerHeight', `${this.headerHeight}px`);
      document.body.style.setProperty('--headerDynamicHeight', `0px`);
    }
  }

  customElements.define('basic-header', BasicHeader, { extends: 'header' });

  class HeaderButton extends HTMLElement {
    constructor() {
      super();
      this.hamburgerWrapper = document.body.querySelector('hamburger-wrapper');
      this.hamburgerCloseBtn = document.body.querySelector('[hamburger-close]');
      this.initEvents();
    }

    initEvents() {
      // Open menu on click of this button
      this.addEventListener('click', () => this.openHamburger());

      // Close menu on close button click
      this.hamburgerCloseBtn?.addEventListener('click', () => this.closeHamburger());

      // Close menu when clicking on overlay
      document.body.addEventListener('click', (event) => {
        if (event.target.classList.contains('page-overlay')) {
          this.closeHamburger();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === "Escape" && this.hamburgerWrapper.classList.contains('active')) {
         this.closeHamburger();
        }
      });

      theme.onMobileSizeChange((isMobile) => {
        if (isMobile) {
          // if ( document.body.classList.contains('has-header-overlay')) {
          this.hamburgerWrapper.classList.remove('active');
          document.body.classList.remove('overflow-hidden');
          // }
        }
      });
    }

    openHamburger() {
      if (!this.hamburgerWrapper) return;
      this.hamburgerWrapper.classList.add('active');
      document.body.classList.add('overflow-hidden');

      setTimeout(() => {
        trapFocus(this.hamburgerWrapper,this.hamburgerCloseBtn);
      }, 500);
    }

    closeHamburger() { 
      if (!this.hamburgerWrapper) return;

      const { dataset } = this.hamburgerWrapper;

      // if (dataset.openMenu === 'click') {
        this.hamburgerWrapper
          .querySelectorAll('.hamburger-menu-item.open, [nav-child-links].open')
          .forEach((item) => item.classList.remove('open'));
        this.hamburgerWrapper
          .querySelectorAll('[nav-links]')
          .forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));
      // }

      this.hamburgerWrapper.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      
       setTimeout(() => {
        this.querySelector('button')?.focus();
      }, 500);
      // document.body.classList.remove('has-header-overlay');
    }
  }
  customElements.define('header-hamburger-btn', HeaderButton);

  } catch(e) { console.error(e); }
})();
})();
